import React from "react";
import EditableCell from "./EditableCell";
import EditableRow from "./EditableRow";
import { Table } from "antd";
import { TableProps, ColumnsType } from "antd/lib/table";
import EditInlineCardExtra from "../EditCard/EditCardExtra";

interface EditableCellItem {
  id: string;
  editable: true;
  title: string;
}

export interface EditableTableProps<T extends EditableCellItem> extends TableProps<T> {
  editMode?: boolean;
  showActionColumn?: boolean;
  onDelete?: (record: T) => void;
  onSave?: (record: T) => void;
}

const EditableTableComponent = function <T extends EditableCellItem>({
  dataSource,
  columns = [],
  editMode = false,
  showActionColumn,
  onSave,
  onDelete,
  ...rest
}: EditableTableProps<T>) {
  const components = {
    body: {
      row: EditableRow,
      cell: EditableCell,
    },
  };

  const handleDelete = (record: T) => {
    if (onDelete) {
      onDelete(record);
    }
  };

  const handleSave = (record: T) => {
    if (onSave) {
      onSave(record);
    }
  };

  const renderActionColumn = (text: string, record: T) => {
    return editMode && showActionColumn ? <EditInlineCardExtra onConfirm={() => handleDelete(record)} /> : null;
  };

  const formattedColumns = columns.map((col: any) => {
    if (!col.editable) {
      return col;
    }
    return {
      ...col,
      onCell: (record: T) => ({
        record,
        editable: col.editable,
        dataIndex: col.dataIndex,
        title: col.title,
        editMode: editMode,
        handleSave,
        key: record.id,
        inputType: col.inputType,
      }),
    };
  });

  const withDeleteColumn = [
    ...formattedColumns,
    {
      title: "",
      width: "20%",
      align: "right",
      dataIndex: "operations",
      render: renderActionColumn,
    },
  ] as ColumnsType<T>;

  return (
    <Table
      rowKey="id"
      dataSource={dataSource}
      columns={withDeleteColumn}
      components={components}
      pagination={false}
      {...rest}
    />
  );
};

export default Object.assign(EditableTableComponent, EditableCell, EditableRow);
